import { ISwitchMenuItem } from '@libs/interfaces';

export const AccountMenu: ISwitchMenuItem[] = [
  {
    index: 0,
    icon: 'settings',
    label: 'Dados',
    route: 'me',
  },
  {
    index: 1,
    icon: 'transactions-accordion',
    label: 'Transações',
    route: 'movements',
  },
  {
    index: 2,
    icon: 'game-history',
    label: 'Historico',
    route: 'game-history',
  },
];
export const wei = 1000000000000000000;

export const WalletMenu: any[] = [
  { index: 0, label: 'Depositar', route: 'deposits' },
  { index: 1, label: 'Retirar', route: 'withdraws' },
];
